import { createContext } from "react";
import { AuthContext } from "./useAuth";

const Context = createContext({} as AuthContext);

export default Context;
